module.exports = "https://coursera_assets.s3.amazonaws.com/images/8426f0f76a81973ce97faa16a40723c5.png";